<template>
  <div>
    <b-card>
      <grupo-notificacao-list
        ref="grupoNotificacaoList"
        :carregar="carregar"
        :novo="novo"
        :editar="editar"
        :colunas="colunasListagem"
        :filtros="filtrosPrincipais"
        :info="info"
        :remover="remover"
        :mostrar-remover-lote="false"
      >
        <template
          slot="icones-acao"
          slot-scope="{ props }"
        >
          <b-btn
            v-b-tooltip.hover
            title="Editar Notificação"
            variant="none"
            class="btn-none rounded-pill icone-acao"
            @click="editar(props.row)"
          >
            <font-awesome-icon
              :icon="['fas', 'magnifying-glass-chart']"
              size="xl"
              color="var(--primary)"
            />
          </b-btn>
          <b-btn
            v-b-tooltip.hover
            title="Excluir Notificação"
            variant="none"
            class="btn-none rounded-pill icone-acao"
            @click="remover([props.row])"
          >
            <font-awesome-icon
              :icon="['fas', 'arrow-right-arrow-left']"
              size="xl"
              color="var(--primary)"
            />
          </b-btn>
        </template>
      </grupo-notificacao-list>
    </b-card>
    <grupo-notificacao-modal
      ref="grupoNotificacaoModal"
      @notification-group-saved="atualizarLista"
    />
  </div>
</template>
<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import api from '@/app-modulo/comuns/notificacao/shared/services/api'

export default {
  name: 'ListaGrupoNotificacao',
  components: {
    FontAwesomeIcon,
    GrupoNotificacaoList: () => import('@/shared/components/visualizacao-base/VisualizacaoBase.vue'),
    GrupoNotificacaoModal: () => import('@/app-modulo/comuns/notificacao/shared/components/cadastros/GrupoNotificacaoModal.vue'),
  },
  data() {
    return {
      colunasListagem: [
        { label: 'Nome do Grupo', field: 'nome' },
        { label: 'Data de Criação', field: 'dataCadastro' },
      ],
      filtrosPrincipais: [],
      info: [],
    }
  },
  methods: {
    atualizarLista() {
      if (this.$refs.grupoNotificacaoList) {
        this.$refs.grupoNotificacaoList.montarGrid()
      }
    },
    carregar(page, pageSize, filtro) {
      const filtros = {
        filtroPrincipal: filtro,
      }
      return api.getGruposNotificacoesPaginado(page, pageSize, filtros)
    },
    novo() {
      this.$refs.grupoNotificacaoModal.abrir()
    },
    editar(value) {
      this.$refs.grupoNotificacaoModal.abrir(value.id)
    },
    remover(values) {
      const idList = values.map(item => item.id)
      return api.deleteGrupoNotificacoes(idList[0])
        .then(response => response)
        .catch(err => err)
    },
  },
}
</script>
